module.exports = "https://r.nearpod.com/assets/media/image/google-icon-07b2f53abef3c85294cf9419258317d1.svg";